export default {
  // #region首页
  main_collection_function: 'Fonction Collection',
  main_menu_bar_management: 'Gestion de la barre de menu',
  // #region 菜单
  // #region 下载中心
  main_menu_download_center: 'Download Center',
  // #endregion
  // #region 客服系统菜单
  main_menu_icms_system: 'Customer Service Systems',
  main_menu_icms_Intelligent_system: 'Intelligent Customer Service System',
  main_menu_icms_work_order: 'Customer Service Work Orders',
  main_menu_icms_create_work_order: 'Work Order Creation',
  main_menu_icms_order_list: 'Work Order List',
  main_menu_icms_task_list: 'Task List',
  main_menu_icms_export_order_list: 'Import Results Query',
  main_menu_icms_export_order_list_details: 'Import Results Details',
  main_menu_icms_template_settings: 'Template Setup',
  main_menu_icms_route_management: 'Routing Management',
  main_menu_icms_factor_list: 'Factor Management',
  main_menu_icms_basic_data_list: 'Basic data maintenance',
  main_menu_icms_task_list_detail: 'Task list details',
  main_menu_icms_order_list_detail: 'Work order list details',
  main_menu_icms_payment_order_detail: 'Details of compensation',
  main_menu_icms_import_payment_order_detail: 'Import compensation result query details',
  main_menu_icms_data_report: 'Data chart',
  main_menu_icms_status_flow_report: 'Status flow chart',
  main_menu_icms_issue_type_report: 'Issue type statistics',
  main_menu_icms_source_report: 'Source statistics chart',
  main_menu_icms_work_order_reply_report: 'Work order response statistics',
  main_menu_icms_process_management: 'Process management',
  main_menu_icms_process_update: 'Editing process',
  main_menu_icms_process_create: 'Creation process',
  main_menu_icms_process_view: 'View process',
  main_menu_icms_process_ticket: 'Quick query',
  main_menu_icms_yun_order_detail: 'Yun work order details',
  main_menu_icms_my_work_order: 'My Work Orders',
  main_menu_icms_oversea_piece: 'Work Order Over Sea',
  main_menu_icms_other_piece: 'Other Work Orders',
  main_menu_icms_work_question: 'Problem Parcel',
  main_menu_icms_advice_complaint: 'Enquiry/Tracking/Complaint',
  main_menu_icms_advice_complaint_details: 'Enquiry/Tracking/Complaint Details',
  // #endregion
  // #region 消息投递菜单
  main_menu_middleware: 'Middleware',
  main_menu_middleware_message_delivery: 'Message delivery',
  main_menu_middleware_message_subscribe: 'Message Service Monitoring',
  main_menu_middleware_message_topic: 'Message topics',
  main_menu_middleware_terminal: 'Endpoint Management',
  main_menu_middleware_loserate: 'terminal Topic Details',
  // #endregion
  // #region 数据分发
  main_menu_middleware_data_distribution: 'Data Distribution',
  main_menu_middleware_dataSourceList: 'DataSourceList',
  main_menu_middleware_api_route: 'API Route Management',
  // #endregion
  // #region 资源管理
  main_menu_rcms_resource_management: 'Resource Management',
  main_menu_rcms_channel_manage: 'Channel Management',
  main_menu_rcms_delivery_manage: 'Dispatch Channel Management',
  main_menu_rcms_area_manage: 'Site Resource Management',
  main_menu_rcms_operating_outlet: 'Operational Point Management',
  main_menu_rcms_airport: 'Airport management',
  main_menu_rcms_harbor: 'port management',
  main_menu_rcms_port: 'Port management',
  main_menu_rcms_transport_manage: 'Capacity Resource Management',
  main_menu_rcms_air_manage: 'Air transport resource management',
  main_menu_rcms_car_manage: 'Vehicle Management',
  main_menu_rcms_push_record: 'Push Records',
  main_menu_rcms_export_detail: 'Export details',
  // #endregion
  // #region 日志监控
  main_menu_server_log_monitor: 'Log Monitoring',
  main_menu_server_audit_log: 'Audit Logs',
  main_menu_server_business_log: 'Business Logs',
  main_menu_server_application_log: 'Application Logs',
  // #endregion
  // #region 用户中心
  main_menu_usercenter_system: 'User Centre Management System',
  main_menu_usercenter: 'User Center',
  main_menu_usercenter_notice_manage: 'Announcement and Message Management',
  // #endregion
  // #region 权限管理
  main_menu_permission_title: 'Permissions Management',
  main_menu_permission_site_authorization: 'Site Permissions Management',
  main_menu_permission_clients_menu: 'Menu Management',
  main_menu_permission_role: 'Role Management',
  main_menu_permission_dimension: 'Data Permissions',
  main_menu_permission_site_userControl: 'User List',
  main_menu_permission_user_authorization: 'User authorization management',
  main_menu_permission_resource_management: 'Data resource management',
  main_menu_permission_operation_log_permission: 'Operation Log - Permissions',
  main_menu_permission_user_import: 'User bulk import',
  // #endregion
  // #region 网站管理
  main_menu_permission_menu_manage: 'Site Management',
  main_menu_permission_menu_list: 'Site menu management',
  main_menu_permission_route_list: 'Site page management',
  // #endregion
  // #region 用户管理
  main_menu_permission_user_management: 'User Management',
  main_menu_permission_post_manager: 'Job Management',
  main_menu_permission_user_login_log: 'User Login Log',
  main_menu_permission_operation_log_employee: 'Operation Log - Users',
  // #endregion
  // #region 组织机构管理
  main_menu_permission_organization_management: 'Organization Management',
  main_menu_permission_subtree: 'Subtree Management',
  main_menu_permission_subtree_detail: 'Subtree management details',
  main_menu_permission_signing_node_belongs: 'Node belongs to the contracting body',
  main_menu_permission_base_organization: 'Base Tree Management',
  main_menu_permission_operation_log_institution: 'Operation Log - Organization',
  main_menu_permission_resource_detail: 'Resource Authorisation',
  main_menu_permission_role_details: 'Role Details Page',
  main_menu_permission_role_resource_authorization: 'Role Resource Authorisation',
  main_menu_permission_role_authorization: 'Role Authorisation Management',
  // #endregion
  // #region 基础数据
  main_menu_basicdata_title: 'Base Data',
  main_menu_basicdata_table_meta_data: 'Table Metadata',
  main_menu_basicdata_word_statistics: 'Word statistics',
  main_menu_basicdata_word_manage: 'Word Management',
  main_menu_basicdata_public_manage: 'Base data list',
  main_menu_basicdata_key_manage: 'Secret Key Management',
  main_menu_basicdata_web_wordstatistics: 'Front-end entry statistics',
  main_menu_basicdata_web_wordmanage: 'Front-end entry management',
  // ==== 基础数据ant =====
  main_menu_antbasicdata_title: 'Base Data(ant)',
  main_menu_antbasicdata_table_meta_data: 'Table Metadata',
  main_menu_antbasicdata_word_statistics: 'Word statistics',
  main_menu_antbasicdata_word_manage: 'Word Management',
  main_menu_antbasicdata_public_manage: 'Base data list',
  main_menu_antbasicdata_key_manage: 'Secret Key Management',
  main_menu_antbasicdata_web_wordstatistics: 'Front-end entry statistics',
  main_menu_antbasicdata_web_wordmanage: 'Front-end entry management',
  // #endregion
  // #region 小云工单
  main_menu_business_title: 'Yun work Orders',
  main_menu_business_workorder: 'Yun work order list',
  main_menu_business_form_type: 'Yun Work Order Types',
  main_menu_business_form_template: 'Yun work order form template library',
  main_menu_business_route: 'Yun work order routing rules',
  main_menu_business_staffs: 'Yun Work Order Member Management',
  main_menu_business_schedule: 'Yun Workday Configuration',
  main_menu_business_report_title: 'Yun Work Order Statistics',
  main_menu_business_report_order: 'Work Order Statistics',
  main_menu_business_export_order: 'Work order export information',
  main_menu_business_statistics: 'Work order details',
  main_menu_business_notice: 'Yun work order announcement',
  // #endregion
  // #region 运维工单
  main_menu_business_owos_ops: 'Maintenance Work Orders',
  main_menu_business_owos_ops_form_type: 'O&M Work Order Types',
  main_menu_business_owos_ops_form_template: 'O&M Work Order Form Template Library',
  main_menu_business_owos_ops_workorder: 'O&M Work Order List',
  main_menu_business_owos_ops_route: 'O&M Work Order Routing Rules',
  main_menu_business_owos_ops_staffs: 'O&M Work Order Member Management',
  main_menu_business_owos_ops_report: 'O&M work order statistics',
  // #endregion
  // #region 需求管理
  main_menu_business_require_management: 'Requirement Management',
  main_menu_business_require_create: 'Requirement creation',
  main_menu_business_require_kanban: 'Requirement Kanban',
  main_menu_business_require_business: 'Business Requirement Pooling',
  main_menu_business_require_product: 'Product Requirement Pool',
  main_menu_business_require_record: 'TAPD Flow Record',
  main_menu_business_require_help: 'Help Center',
  main_menu_business_require_detail: 'Requirement Details',
  main_menu_business_require_edit: 'Editing Requirements',
  main_menu_business_require_system: 'Requirements System Management',
  main_menu_business_require_organization: 'Requirements organisation',
  main_menu_business_require_people: 'Requirements staff management',
  // #endregion
  // #region 服务器管理
  main_menu_server_list: 'Server Management',
  // #endregion
  // #region 服务商账号管理
  main_menu_ctms_title: 'Service Provider Account Management',
  main_menu_ctms_account_manage: 'Account Management',
  main_menu_ctms_login_log: 'Login log',
  // #endregion
  // #region 航空提货
  main_menu_ctms_air_delivery: 'CTMS',
  main_menu_ctms_port_delivery: 'Air pick-up',
  main_menu_ctms_order_manage: 'AWB',
  main_menu_ctms_NOA_manage: 'NOA',
  main_menu_ctms_pickup_task_manage: 'Task',
  main_menu_ctms_exception_manage: 'Exception',
  main_menu_ctms_backlog_manage: 'Air pickup pending tasks',
  // #endregion
  // #region 资源组管理
  main_menu_resource_title: 'Resource Group Management',
  main_menu_resource_workbench: 'Resource Group Workbench',
  main_menu_resource_cost_board: 'Resource Cost Board',
  main_menu_resource_application_modify: 'Resource Requirements',
  main_menu_resource_apply_list: 'Resource Requirement List',
  main_menu_resource_group_details: 'Resource Requirement Details',
  main_menu_resource_hardware_specification: 'Hardware Configuration Management',
  main_menu_resource_middleware_type: 'Middleware Type Management',
  main_menu_resource_entrypoint: 'Access Point Management',
  main_menu_resource_load_balancer: 'Load Balancer',
  main_menu_resource_cluster: 'Cluster Management',
  main_menu_resource_environment: 'Environment Management',
  main_menu_resource_middleground: 'R&D Centre',
  main_menu_resource_system: 'System Management',
  main_menu_resource_system_detail: 'System Resource Details',
  main_menu_resource_preview: 'Resource Preview Page',
  // #endregion
  // #region Deploy3
  main_menu_deploy_title: 'Deploy3',
  main_menu_deploy_real_time: 'Real-time Deployment Statistics',
  main_menu_deploy_statistics: 'Deployment Statistics',
  main_menu_deploy_application: 'Application Management',
  main_menu_deploy_deployment: 'Deployment Management',
  main_menu_deploy_deployment_detail: 'Deployment Details',
  main_menu_deploy_relationship: 'Relationship Management',
  main_menu_deploy_deployment_status: 'Deployment Status',
  main_menu_deploy_frontend_deploy: 'Front End Package Management Site',
  main_menu_deploy_frontend_deploy_detail: 'Front-end package management details',
  main_menu_deploy_app_manage_system: 'System Information',
  // #endregion
  // #region 轨迹管理-tis
  main_menu_tis_new_Track_system: 'New TIS Track System',
  main_menu_tis_title: 'Track Management',
  main_menu_tis_search: 'Track query',
  main_menu_tis_track_query_list: 'Track query list',
  main_menu_tis_track_archiving: 'Archived Track Queries',
  main_menu_tis_add_track_approval: 'Edit Track Review',
  main_menu_tis_track_repair_result: 'Track Repair Results Query',
  main_menu_tis_aging_standard: 'Standard aging configuration',
  main_menu_tis_monitor_statistics: 'Track Node Monitoring',
  main_menu_tis_numbers_relation: 'Track single number association',
  main_menu_tis_dataDownload: 'TIS Data Download Centre',
  main_menu_tis_unmatcNode: 'Unmatched Node Query',
  main_menu_tis_configuration_management: 'Track Configuration Management',
  main_menu_tis_facilitator: 'TIS service provider management',
  main_menu_tis_channel: 'TIS Channel Management',
  main_menu_tis_tracking_node: 'Track Node Management',
  main_menu_tis_track_business: 'Track business stage management',
  main_menu_tis_track_examine: 'Service provider track rule review',
  main_menu_tis_track_subscription_managemeent: 'Track Subscription Management',
  main_menu_tis_track_query_listDes: 'Operating event details',
  main_menu_tis_track_query_listDesOut: 'External track details',
  main_menu_tis_track_view_fbaChild: 'View FBA sub order',
  main_menu_tis_channel_relation: 'Packing & TIS Channel Setting',
  main_menu_tis_node_deployment: 'LTS & TIS Node Setting',
  main_menu_tis_track_config: 'Track Policy Configuration',
  main_menu_tis_awb_query: 'Yun Freight track',
  main_menu_tis_awb_detail: 'Yun Freight tracking details',
  main_menu_tis_awb_management: 'Yun Freight track management',
  main_menu_tis_track_notification: 'Track Notification Management',
  main_menu_tis_report_analysis: 'Track report analysis',
  main_menu_tis_timeliness_report: 'Track timeliness report',
  main_menu_tis_timeliness_details: 'Timeliness exception details',
  main_menu_tis_general_query: 'Track general query',
  main_menu_tis_push_config: 'Configuration of external tracking',
  main_menu_tis_push_monitor: 'Monitoring of pushing track',
  main_menu_tis_flight_info: 'Flight information configuration',
  // #endregion
  // #region 工作台管理
  main_menu_wfs_work_system: 'Workbench System',
  main_menu_wfs_title: 'Workbench Management',
  main_menu_wfs_workbench_management: 'Backend Management',
  main_menu_wfs_module_manage: 'Module Management',
  main_menu_wfs_data_manage: 'Data flow management',
  main_menu_wfs_shortcut_manage: 'Quick Entry Management',
  main_menu_wfs_system_setting: 'System settings',
  main_menu_wfs_type_manage: 'Business Type Management',
  main_menu_wfs_priority_manage: 'Priority Management',
  main_menu_wfs_config_center: 'Configuration Centre',
  main_menu_wfs_message_record: 'Message record Search',
  main_menu_wfs_station_message: 'Station message management',
  main_menu_wfs_saturation_factor: 'Saturation Rate Configuration',
  main_menu_wfs_items: 'Matter Configuration',
  main_menu_wfs_dictionary: 'Data Configuration',
  main_menu_wfs_clearance_manager: 'Customs clearance document manager',
  main_menu_wfs_batch_process: 'Batch processing',
  main_menu_wfs_complaint_deal: 'Transfer processing',
  main_menu_wfs_todo_center: 'Todo Centre',
  main_menu_wfs_message: 'Message Alerts',
  main_menu_wfs_create_quick: 'Create a shortcut',
  main_menu_wfs_quick_setting: 'Shortcut portal settings',
  // #endregion
  // #region 工单系统
  main_menu_wos_title: 'Work Order System',
  main_menu_wos_workbench: 'Workbench',
  main_menu_wos_rule: 'Basic assignment rules',
  main_menu_wos_import_result: 'Import Results Enquiry',
  main_menu_wos_work_type: 'Work order type maintenance',
  main_menu_wos_question: 'Problem Work Orders',
  main_menu_wos_add_rule: 'Add Rules',
  main_menu_wos_import_detail: 'Import Details',
  main_menu_wos_import_result_detail: 'Import Results Detail',
  main_menu_wos_order_detail: 'Work Order Details',
  main_menu_wos_return_redispatch_channel: 'Return channel',
  main_menu_wos_abnormal_bill: 'Abnormal bill of lading query',
  main_menu_wos_my_work_order: 'My Work Orders',
  main_menu_wos_oversea_piece: 'Work Order Over Sea',
  main_menu_wos_work_question: 'Problem Parcel',
  main_menu_wos_advice_complaint: 'Enquiry/Tracking/Complaint',
  main_menu_wos_advice_complaint_details: 'Enquiry/Tracking/Complaint Details',
  main_menu_wos_workbench_new: 'Workbench',
  main_menu_wos_other_order: 'Other Work Orders',
  // #endregion
  // #region 提成返点
  main_menu_crms_title: 'Commission rebate',
  main_menu_crms_object_bind: 'Object binding management',
  main_menu_crms_bill_data: 'Billing data management',
  main_menu_crms_rebate_bill: 'Rebate Billing Management',
  main_menu_crms_bill_download: 'Billing Download',
  main_menu_crms_rule_config: 'Rules configuration management',
  // #endregion
  // #region 网上订单管理
  main_menu_oms_order_list: 'Online Order Management',
  // #endregion
  // #region 计划任务
  main_menu_cron_planing_list: 'Scheduled tasks',
  // #endregion
  // #region 客户端管理
  main_menu_client_title: 'Client Management',
  main_menu_client_aisle: 'Channel List',
  main_menu_client_instance: 'Instance list',
  main_menu_client_key: 'Activation code list',
  main_menu_client_apply: 'Application List',
  main_menu_client_apply_detail: 'Application List Details',
  // #endregion
  // #region 航空竞价
  main_menu_rbs_title: 'Air Bids',
  main_menu_rbs_list: 'Bid List',
  main_menu_rbs_create_rule: 'Resource Generation Rules',
  main_menu_rbs_assess: 'Assessment Management List',
  main_menu_rbs_assess_details_post: 'Assessment Details',
  main_menu_rbs_audit: 'Project results audit list',
  main_menu_rbs_audit_details_post: 'Final Audit Details',
  main_menu_rbs_capacity: 'Project Resource Management List',
  main_menu_rbs_capacity_resource_list: 'Resource List Details',
  // #endregion
  // #region 前端词条管理
  main_menu_tsn_title: 'Front-End Word Management',
  main_menu_tsn_system: 'Front-end entry system management',
  main_menu_tsn_log: 'Front-end entry maintenance log',
  main_menu_tsn_translation: 'Front-end entries list',
  main_menu_tsn_wordstatistics: 'Front-end entry statistics',
  // #endregion
  // #region 项目立项管理
  main_menu_pms_project_management_system: 'Project Management System',
  main_menu_pms_title: 'Project Management',
  main_menu_pms_projectList: 'Project List',
  main_menu_pms_dashboard: 'Project Dashboard',
  main_menu_pms_projectList_form: 'Project details',
  main_menu_IT_portalIT: 'IT Portal',
  main_menu_basic_framework: 'Foundation Framework Management System',
  main_menu_customer_management_system: 'Customer Point Management System',
  main_menu_route_login: 'Login',
  main_menu_route_work_title: 'Workbench',
  main_menu_route_find_password: 'Find your Password',
  // #endregion
  // #region 网络规划
  main_menu_lnms_network_plan_management: 'Network planning management',
  main_menu_lnms_shift_manage: 'Shift management',
  main_menu_lnms_collect_shift_manage: 'Collect shift management',
  main_menu_lnms_customs_shift_manage: 'Customs shift management',
  main_menu_lnms_combination_shift_manage: 'Combined shift management',
  main_menu_lnms_operation_shift_manage: 'Operation shift management',
  main_menu_lnms_transport_shift_manage: 'Transportation shift management',
  main_menu_lnms_airline_shift_manage: 'Air transport shift management',
  main_menu_lnms_truck_shift_manage: 'Land transportation shift management',
  main_menu_lnms_delivery_shift_manage: 'Dispatch shift management',
  main_menu_lnms_route_manage: 'Routing management',
  main_menu_lnms_route_list: 'Routing list',
  main_menu_lnms_product_route_list: 'Product routing list',
  main_menu_lnms_basic_data_list: 'Basic data management',
  main_menu_lnms_attribute_list: 'Attribute management',
  main_menu_lnms_constraint_list: 'Constraint management',
  main_menu_lnms_route_template_list: 'Line template management',
  main_menu_lnms_direction_of_destination: 'Destination flow direction',
  main_menu_lnms_import_list: 'Import list',
  main_menu_lnms_export_list: 'Export list',
  // #endregion
  // #region 陆运管理系统
  main_menu_ltms_Land_transport_management_system: 'Land Transportation Management System',
  main_menu_ltms_transportation_management: 'Transportation management',
  main_menu_ltms_transport_demand: 'Transport Requirement',
  main_menu_ltms_transport_order: 'Shipping order',
  main_menu_ltms_transport_task: 'Transport task',
  main_menu_ltms_basic_data: 'Base Data',
  main_menu_ltms_customer_management: 'Customer management',
  main_menu_ltms_address_management: 'Address management',
  main_menu_ltms_carrier_management: 'Carrier Management',
  main_menu_ltms_carrier_priority_rules: 'Carrier Priority Rules',
  main_menu_ltms_line_management: 'Line management',
  main_menu_ltms_carrier_quote: 'Carrier Quote',
  main_menu_ltms_system_management: 'System Management',
  main_menu_ltms_platform_management: 'Platform management',
  main_menu_ltms_mail_management: 'Mail management',
  main_menu_ltms_mail_list: 'Mailing list',
  main_menu_ltms_mail_setting: 'Mail configuration',
  main_menu_ltms_check_bill: 'Bill reconciliation',
  main_menu_ltms_estimated_cost: 'Estimated cost',
  main_menu_ltms_import_bill: 'Bill import',
  main_menu_ltms_bill_checked: 'Invoice reconciled',
  main_menu_ltms_evaluation_management: 'Inquiry management',
  main_menu_ltms_tevaluation_demand: 'Inquiry demand',
  // #endregion
  // #endregion

  // #region Header
  main_header_recent_visit: 'Recent visits',
  main_header_placeholder: 'Search',
  main_header_IT_system: 'Systèmes informatiques',
  main_header_todo_center: 'ToDo Centre',
  main_header_message_remind: 'Message Alerts',
  main_header_change_SYS_password: 'Modifier le mot de passe',
  main_header_log_out: 'Logging out',
  main_header_log_out_tip: 'Confirm logout',
  main_header_log_out_title: 'Sign out prompt',
  main_header_confirm: 'Confirm',
  main_header_cancel: 'Cancel',
  main_header_change_name: 'Name',
  main_header_change_Work_number: 'ZT number',
  main_header_old_password: 'Old password',
  main_header_old_password_placeholder: 'Please enter your initial password',
  main_header_new_password: 'New password',
  main_header_new_password_placeholder: 'Please enter new password',
  main_header_confirm_password: 'Confirm Password',
  main_header_confirm_password_placeholder: 'Please confirm your password',
  main_header_messageObj_prompt: 'Prompt',
  main_header_messageObj_length: 'The password length must be 8 to 16 characters',
  main_header_messageObj_three_condition:
    'It needs to include three or more of the following: uppercase letters, lowercase letters, numbers, and special symbols',
  main_header_messageObj_no_repeat:
    'Sequential or repeated numbers of three or more characters are not allowed (e.g., 345, 333)',
  main_header_messageObj_old_new_different: 'Old and new passwords cannot be the same',
  main_header_messageObj_twice_different: 'The password entered twice must be consistent',
  main_header_change_success: 'Modify successfully',
  main_header_refresh: 'Refresh',
  main_header_close: 'Close',
  main_header_close_all: 'Close all',
  main_header_close_addition: 'Close all else',
  main_header_close_right: 'Close all on the right side of the current page',
  main_header_close_left: 'Close all on the left side of the current page',
  // #endregion

  // #region 首页
  main_home_home_name: 'Home',
  main_home_todo_title: 'My to-do list',
  main_home_todo_more: 'More',
  main_home_todo_checkAll: 'Select all',
  main_home_todo_batchProcess: 'Batch processing',
  main_home_todo_complaint: 'Transfer',
  main_home_todo_approve: 'Approved',
  main_home_todo_reject: 'Reject',
  main_home_todo_toDealWith: 'Go to processing',
  main_home_todo_work_dealed: 'Congratulations, you have finished processing your work!',
  main_home_todo_no_data: 'No data available',
  main_home_todo_current_select: 'Currently selected',
  main_home_todo_data_num: 'Data',
  main_home_todo_all: 'All',
  main_home_todo_approve_tip: 'Is this data confirmed as approved',
  main_home_todo_approve_title: 'Approved',
  main_home_todo_confirm: 'Confirm',
  main_home_todo_cancel: 'Cancel',
  main_home_todo_approve_success: 'Approved!',
  main_home_todo_reject_title: 'Rejected',
  main_home_todo_reject_reason: 'Please fill in the reason for rejection',
  main_home_todo_reject_success: 'Rejection processed successfully!',
  main_home_quick_title: 'Shortcut entrance',
  main_home_quick_create: 'Create shortcut',
  main_home_quick_cancel_common: 'Cancel common',
  main_home_quick_set_common: 'Set as frequently used',
  main_home_quick_sort: 'Sort by',
  main_home_quick_recommend: 'Set as recommended app',
  main_home_quick_add_common: 'Add to frequently used',
  main_home_quick_no_data: 'No data available',
  main_home_quick_cancel_common_success: 'Cancel Popular Success!',
  main_home_quick_set_common_success: 'Set as common successful!',
  main_home_quick_recommend_success: 'Success in setting as a recommended application!',
  main_home_report_transhipment: 'Forwarding - Air Freight',
  main_home_report_no_data: 'No data available',
  main_home_report_clearance: 'Customs clearance information',
  main_home_report_risk_control: 'Customs - Risk Control',
  // #endregion

  // #region request tips
  main_request_tip_exist_environ: 'Environment does not exist',
  main_request_tip_login_expired: 'Login has expired, please login again',
  main_request_tip_no_legal: 'No permission, please contact the administrator',
  main_request_tip_server_error: 'Server side error, please contact administrator',
  main_request_504_error: "Délai d'expiration de la passerelle, veuillez réessayer",
  main_request_tip_system_error: 'System error, please contact administrator',
  main_request_tip_timeout: 'Requirement timeout, please refresh and try again',
  main_request_copy_success: 'Copied successfully',
  main_requestt_tip_confirm: 'OK',
  main_request_tip_cancel: 'Cancel',
  main_request_tip_delete_success: 'Deleted successfully',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: 'Welcome to the GOFO system',
  main_login_loading_failure: 'Environment failed to load, please refresh and try again',
  main_login_morning_greetings: 'Good morning',
  main_login_noon_greetings: 'Good afternoon',
  main_login_afternoon_greetings: 'Good afternoon',
  main_login_night_greetings: 'Good evening',
  main_login_account: 'Account number',
  main_login_placeholder_input: 'Please enter',
  main_login_password: 'Password',
  main_login_retrieve_password: 'Find your password',
  main_login_btn_text: 'Login',
  main_login_account_tip: 'Please enter your account number',
  main_login_password_tip: 'Please enter your password',
  main_login_accountMap_LDAP: 'Domain',
  main_login_accountMap_SYS: 'GOFO Systems',
  main_login_accountMap_CAS: 'Zongteng Intranet',
  main_login_account_error: 'Account password error',
  main_login_retrieve_back: 'Back',
  main_login_select_account: 'Select the account to be retrieved',
  main_login_select_way: 'Select recovery method',
  main_login_authentication: 'Identity verification',
  main_login_reset_password: 'Reset password',
  main_login_work_number: 'ZT number',
  main_login_work_number_tip: 'Please enter the work number to be recovered',
  main_login_customer_tip: 'You are resetting your password for',
  main_login_operation_tip: 'to reset your password',
  main_login_verification_code:
    'Click to get the verification code, an email will be sent to your email address',
  main_login_verification_code_tip: 'Please enter the verification code',
  main_login_send_verification_code: 'Send verification code',
  main_login_name: 'Name',
  main_login_new_password: 'New password',
  main_login_new_password_tip: 'Please enter a new password',
  main_login_new_password_again_tip: 'Enter new password again',
  main_login_next_step: 'Next step',
  main_login_save: 'Save',
  main_login_reset_password_succeeded: 'Password reset successful, please login again',
  main_login_work_number_input: 'Please enter your work number',
  main_login_six_verification_code6: 'Please enter the 6-digit verification code',
  main_login_mail: 'By email',
  main_login_unknown_way: 'Unknown authentication method',
  main_login_get_in: 'Please be patient as you enter the system',
  main_login_no_exist_page: 'You do not have permission or the page does not exist',
  main_login_no_exist_page_tip:
    'Please check if the path is correct or click on the button to go back to the home page, if you have any problems please contact the administrator',
  main_login_no_exist_backBack: 'Back to home',
  main_login_no_last_back: 'Back',
  // #endregion

  // #region 物流控制塔-lct
  main_menu_lct: 'LCT',
  main_menu_lct_basic_data: 'Basic data',
  main_menu_lct_ware_op: 'In-house operations OTIF (On-time in full) standards',
  main_menu_lct_ware_tr: 'In-house transit OTIF (On-time in full) standards',
  main_menu_lct_ware_de: 'Warehouse outbounding delivery OTIF (On-time in full) standards',
  main_menu_lct_flight_exce: 'OTP (On-time Performance) for flight exceptions',
  main_menu_lct_noa_exce: 'Abnormal NOA OTP (On-time Performance) standards',
  main_menu_lct_customs_clear: 'Standard Timeliness of  customs clearance exception',
  main_menu_lct_pick_up: 'Standard Timeliness of airport pick-up exception',
  main_menu_lct_exce_type: 'Exception type maintenance',
  main_menu_lct_exce_relation: 'View the relation',
  main_menu_lct_report: 'Real-time report',
  main_menu_lct_report_port: 'Port-to-lastmile transshipment Report',
  main_menu_lct_report_ware_work: 'Warehouse Operation Report',
  main_menu_lct_report_ware_tr: 'Warehouse Transit Report',
  main_menu_lct_report_de_service: 'Last-mile Handovering Report',
  main_menu_lct_report_overseas: 'Overseas Transhipment Report',
  main_menu_lct_report_exce: 'Report analysis',
  main_menu_lct_report_exce_ab: 'Abnormal bill of lading report',
  main_menu_lct_report_exce_type: 'ATA TO Ascan',
  main_menu_lct_flight_arrive: 'ATA Monitoring',
  main_menu_lct_pickup_notice: 'NOA Monitoring',
  main_menu_lct_airport_pickup: 'Airport Pick-up Monitoring',
  main_menu_lct_pickup_in_warehouse: 'Check-in Monitoring',
  main_menu_lct_clearance_link: 'Customs Clearence Monitoring',
  main_menu_lct_oversea_all_link: 'Overseas whole Segments Monitoring',
  main_menu_lct_transfer_between_warehouse: 'Warehouse-to-Warehouse Transhipment Monnitoring',
  main_menu_lct_warehouse_work: 'Warehouse Operation Monitoring',
  main_menu_lct_end_of_delivery: 'Handover to Last-mile Monitoring',
  main_menu_lct_end_of_pickup: 'Last-mile Ascan monitoring',
  main_menu_lct_link_board: 'Monitoring Kanban',
  main_menu_lct_delivery_monitor: 'Timely Delivery Rate Report',
  main_menu_lct_delivery_to_arrive: 'Dispatch to ATA',
  main_menu_lct_take_off_monitor: 'Flight departure monitoring',
  main_menu_lct_take_off_standard: 'Airport departure time standard',
  main_menu_lct_delivery_link_monitor: 'Delivery Segment Monitoring',
  main_menu_lct_link_real_time_monitoring: 'Segment Real-Time Monitoring',
  main_menu_lct_run_analysis_report: 'Operating Analysis Report',
  main_menu_lct_aging_standard_configuration: 'Standard Time Configuration',
  main_menu_lct_pass_machine_standard: ' Standard Duration Of DWS-Dispatch',
  main_menu_lct_pass_machine_monitor: 'DWS-Dispatch Monitoring',
  main_menu_lct_dispatch_arrive_monitor: 'Dispatch To Arrive Departure Port Dashboard',
  main_menu_lct_dispatch_arrive_standard: 'Standard Time Of Dispatch To Arrive Departure  Port',
  main_menu_lct_checkout_time_limit_standard: 'Standard Time Of Check Out - Dws',
  main_menu_lct_package_checkout_monitoring: 'Parcels Check-Out Monitoring',
  main_menu_lct_pass_link: 'Dws-Scanning Monintoring',
  main_menu_lct_shared_monitoring: 'SSC Operation Report',
  // #endregion

  // #region 订单履约管理-ofp
  main_menu_ofp: 'Order Fulfillment Management',
  main_menu_ofp_basic_info_manage: 'Basic Infomation Management',
  main_menu_ofp_task_manage: 'Task Management',
  main_menu_ofp_e_directory_manage: 'Exception Catalogue Management',
  main_menu_ofp_e_type_manage: 'Exception Type Management',
  main_menu_ofp_task_type_manage: 'Task Type Management',
  main_menu_ofp_service_type_manage: 'Service Type Management',
  main_menu_ofp_due_manage: 'Normal Fulfillment Management',
  main_menu_ofp_order_task_manage: 'Order Task Management',
  main_menu_ofp_abnormal_ofp_manage: 'Exception Fulfillment Management',
  main_menu_ofp_e_task_manage: 'Exception Task Management',
  main_menu_ofp_e_task_details: 'Exception Task Details',
  main_menu_ofp_abnormal_manage: 'Exception Management',
  main_menu_ofp_block_import: 'Intercept Import',
  main_menu_ofp_e_task_query: 'Exception Task Search',
  main_menu_ofp_abnormal_manage_old: 'Exception Management (Old)',
  main_menu_ofp_e_task_query_old: 'Exception Task Search (Old)',
  main_menu_ofp_abnormal_details: 'Exception Detail',
  main_menu_ofp_abnormal_details_old: 'Exception Detail (Old)',
  main_menu_ofp_rules_manage: 'Fulfillment Rule Management',
  main_menu_ofp_e_process_manage: 'Exception Process Management',
  main_menu_ofp_edit_e_process: 'Edit Exception Process',
  main_menu_ofp_add_e_process: 'Add Exception Process',
  main_menu_ofp_view_e_process: 'View Exception Process',
  main_menu_ofp_create_rules: 'Order Task Generate Rule',
  main_menu_ofp_distribute_rules: 'Task Push Rule',
  main_menu_ofp_forward_task_manage: 'Forward Task Management',
  main_menu_ofp_process_processing: 'Fulfillment Process Processing ',
  main_menu_ofp_process_processing_details: 'Process Processing Detail',
  main_menu_ofp_task_instance: 'Fulfillment Task Instance',
  main_menu_ofp_task_instance_details: 'Task Instance Detail',
  main_menu_ofp_performance_process_manage: 'Fulfillment Process Management',
  main_menu_ofp_block_import_cancel: 'Interception Import and Cancel',
  main_menu_ofp_import_detail_page: 'Interception Import Detail',
  // #endregion

  // #region 运输管理系统
  main_menu_tms_Transport_management_system: 'Transportation Management System',
  main_menu_tms_transportation_management: 'Transportation management',
  main_menu_tms_transport_demand: 'Transport Requirement',
  main_menu_tms_transport_order: 'Shipping order',
  main_menu_tms_transport_task: 'Transport task',
  main_menu_tms_basic_data: 'Base Data',
  main_menu_tms_line_management: 'Line management',
  main_menu_tms_mail_management: 'Mail management',
  main_menu_tms_mail_list: 'Mailing list',
  main_menu_tms_mail_setting: 'Mail configuration',
  // #endregion

  // #region 运输资源管理系统
  main_menu_lrms_Land_resource_management_system: 'Transportation Resource Management System',
  main_menu_lrms_basic_data: 'Base Data',
  main_menu_lrms_address_management: 'Address management',
  main_menu_lrms_carrier_management: 'Carrier Management',
  main_menu_lrms_carrier_priority_rules: 'Carrier Priority Rules',
  main_menu_lrms_carrier_quote: 'Carrier Quote',
  main_menu_lrms_mail_management: 'Mail management',
  main_menu_lrms_mail_list: 'Mailing list',
  main_menu_lrms_mail_setting: 'Mail configuration',
  main_menu_lrms_evaluation_management: 'Inquiry management',
  main_menu_lrms_tevaluation_demand: 'Inquiry demand',
  // #endregion
  // #region 理赔系统
  main_menu_css_claims_reason: 'Configuration compensation reason',
  main_menu_css_region_setting: 'Configuration region and responsible department',
  main_menu_css_special_reason_setting: 'Claim order maintenance',
  main_menu_css_special_reason_list: 'Special claim list',
  main_menu_css_customer_service: 'Customer service',
  main_menu_css_basicdata_title: 'Base Data',
  main_menu_css_claims_type: 'Configuration compensation type',
  main_menu_css_import_record: 'Guide record',
  main_menu_css_batch_import: 'Import of bulk compensations',
  main_menu_css_standard_list: 'List of standard compensation',
  main_css_link_setting: 'Part setting'
  // #endregion
}
